export default {
      id: "oc-res-month-report-subscription-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-month-report-subscription",
      toString: function () {
        return this.url;
      }
    }